export default "__VITE_ASSET__BLrOjXZN__"